module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-cs-items-image-sp-71b53a68229a3305182f775281ecde3a.png";